import { BuildingType, FloorType, AreaType } from "api/schema";
import { startOfToday } from "date-fns";

export interface State {
  selectedDate: Date;
  selectedBuilding?: BuildingType;
  floors: FloorType[];
  selectedFloor?: FloorType;
  telephoneBoxes: AreaType[];
  selectedTelephoneBox?: AreaType;
  hoursStart?: number;
  hoursEnd?: number;
  unavailableSlots: number[];
}

export const initialState: State = {
  selectedDate: startOfToday(),
  floors: [],
  telephoneBoxes: [],
  unavailableSlots: [],
};

export enum ActionType {
  RESET,
  SELECT_BUILDING,
  SELECT_DATE,
  SET_FLOORS,
  SELECT_FLOOR,
  SET_TELEPHONE_BOXES,
  SELECT_TELEPHONE_BOX,
  SET_HOURS_RANGE,
  SET_UNAVAILABLE_SLOTS,
}

export interface Action {
  type: ActionType;
  payload?: unknown;
}
